import React from 'react';
import { getSafeValue } from "../../helpers/helper";

export default function StatusBadge({
  text,
  color = "blue",
  size = "medium",
}) {
  const colorClasses = {
    blue: "bg-blue-100 text-blue-800",
    red: "bg-red-100 text-red-800",
    alert: "bg-red-700 text-white",
    green: "bg-green-100 text-green-800",
    yellow: "bg-yellow-100 text-yellow-800",
    orange: "bg-orange-100 text-orange-800",
  };

  const sizeClasses = {
    small: "px-3 py-1.5 text-sm",
    medium: "px-4 py-2 text-base",
    large: "px-6 py-3 text-lg",
  };

  const colorClass = getSafeValue(colorClasses, color, "blue");
  const sizeClass = getSafeValue(sizeClasses, size, "medium");

  const baseClasses = `
      inline-flex items-center justify-center text-center
      ${colorClass}
      ${sizeClass}
      rounded-xl
      font-semibold
    `;

  return (
    <span className={baseClasses}>
      {text}
    </span>
  );
};
